import { Expand, Plus } from "lucide-react";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_NOTES_TOOLTIPS } from "../constants/menuTooltips";

export default function MenuNotesNav({
  visible = false,
  canCreate = true,
  canExpand = false,
  expandEditing = false,
  onCreate = () => {},
  onExpand = () => {},
}) {
  if (!visible) return null;

  const expandTip = canExpand
    ? expandEditing
      ? MENU_NOTES_TOOLTIPS.expandEdit
      : MENU_NOTES_TOOLTIPS.expand
    : MENU_NOTES_TOOLTIPS.expandDisabled;

  return (
    <div className="menuFilterContainer menuNotesNav">
      <MenuIconTooltip
        tooltip={expandTip}
        placement="left"
        portal
        className={canExpand ? "filterIcon active" : "filterIcon"}
      >
        <Expand
          size={50}
          color={canExpand ? "#39210d" : "#b8a99a"}
          strokeWidth={1}
          onClick={canExpand ? onExpand : undefined}
          aria-label="Afficher la note sur deux pages"
          aria-disabled={!canExpand}
          style={{
            opacity: canExpand ? 1 : 0.3,
            cursor: canExpand ? "pointer" : "default",
          }}
        />
      </MenuIconTooltip>
      <MenuIconTooltip
        tooltip={
          canCreate
            ? MENU_NOTES_TOOLTIPS.create
            : "Nouvelle note ✶ Quittez d'abord le mode édition pour créer une note."
        }
        placement="left"
        portal
        className={canCreate ? "filterIcon active" : "filterIcon"}
      >
        <Plus
          size={50}
          color={canCreate ? "#39210d" : "#b8a99a"}
          strokeWidth={1}
          onClick={canCreate ? onCreate : undefined}
          aria-label="Créer une nouvelle note"
          aria-disabled={!canCreate}
          style={{
            opacity: canCreate ? 1 : 0.3,
            cursor: canCreate ? "pointer" : "default",
          }}
        />
      </MenuIconTooltip>
    </div>
  );
}
